var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigestDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9C6.98528 9 9 6.98528 9 4.5C9 2.01472 6.98528 0 4.5 0C2.01472 0 0 2.01472 0 4.5C0 6.98528 2.01472 9 4.5 9Z",
    fill: "#FBB040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4115 3H4.58851C3.7112 3 3 3.61913 3 4.38286V19.6171C3 20.3809 3.7112 21 4.58851 21H17.4115C18.2888 21 19 20.3809 19 19.6171V4.38286C19 3.61913 18.2888 3 17.4115 3Z",
    fill: "url(#paint0_linear_133_523)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_133_523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 8,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H7V15H15V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_133_523)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.121 13.8731C12.121 14.0962 12.0552 14.3143 11.932 14.4999C11.8089 14.6854 11.6338 14.83 11.429 14.9154C11.2241 15.0008 10.9987 15.0231 10.7813 14.9796C10.5639 14.9361 10.3641 14.8286 10.2074 14.6708C10.0506 14.5131 9.94382 14.312 9.90057 14.0932C9.85732 13.8743 9.87951 13.6475 9.96436 13.4413C10.0492 13.2352 10.1929 13.059 10.3772 12.935C10.5616 12.811 10.7783 12.7449 11 12.7449C11.2973 12.7449 11.5824 12.8637 11.7926 13.0753C12.0029 13.2869 12.121 13.5739 12.121 13.8731Z",
    fill: "#0092C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2774 8H12.9025L11.0013 10.7026L9.0988 8H8.72388H7V14.9388H8.72388V10.4489L9.95123 12.1941H12.05L13.2774 10.4502V14.9388H15V8H13.2774Z",
    fill: "#0092C8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17C19.3284 17 20 16.3284 20 15.5C20 14.6716 19.3284 14 18.5 14C17.6716 14 17 14.6716 17 15.5C17 16.3284 17.6716 17 18.5 17Z",
    fill: "#FBB040"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_523",
    x1: 11,
    y1: 3,
    x2: 11,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68D1FC",
    stopOpacity: 0.64
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigestDocumentIcon);
export default __webpack_public_path__ + "static/media/digestDocumentIcon.5be2f56b565bf97767521754c9069b07.svg";
export { ForwardRef as ReactComponent };